@if (!isAccordion) {
    <section class="widget h-100">
        <ng-container
            *ngTemplateOutlet="
                heading;
                context: { cssClasses: 'widget-header' }
            "
        ></ng-container>

        <ng-container *ngTemplateOutlet="content"></ng-container>
    </section>
} @else {
    <wdx-accordion
        data-cy="widget-team-member"
        [attr.data-cy-value]="getTmService?.membersCount$ | ngrxPush"
        [widget]="true"
    >
        <wdx-accordion-panel
            [open]="(getTmService?.membersCount$ | ngrxPush) > 0"
        >
            <ng-container
                *ngTemplateOutlet="heading; context: { cssClasses: 'mb-0' }"
            ></ng-container>

            <div wdxAccordionContent>
                <ng-container *ngTemplateOutlet="content"></ng-container>
            </div>
        </wdx-accordion-panel>
    </wdx-accordion>
}

<ng-template #heading let-cssClasses="cssClasses">
    <h5 [attr.class]="cssClasses">
        {{ ENTITY_TEAM_SINGULAR | translateTokenisedString }} (<wdx-counter
            [count]="getTmService?.membersCount$ | ngrxPush"
            [hasError]="getTmService?.teamMembersHasError$ | ngrxPush"
            [isLoading]="getTmService?.teamMembersIsLoading$ | ngrxPush"
        ></wdx-counter
        >)
    </h5>
</ng-template>

<ng-template #content>
    <atom-async-data
        class="d-block h-100"
        [isLoading]="
            (getTmService?.teamMembersIsLoading$ | ngrxPush) ||
            (getTmService.addingTeamMembersIsLoading$ | ngrxPush)
        "
        [hasError]="getTmService?.teamMembersHasError$ | ngrxPush"
    >
        <section class="d-flex flex-column h-100">
            <div class="widget widget-body flex-grow-1 overflow-hidden">
                @if (getTmService.teamOwner$ | ngrxPush; as owner) {
                    <section owner class="mb-3" data-cy="section-owner">
                        <div class="d-flex">
                            <molecule-info-card
                                [primaryInfo]="owner?.primaryInfo"
                                [secondaryInfo]="owner?.secondaryInfo"
                                [tertiaryInfo]="owner?.tertiaryInfo"
                                [avatars]="owner?.avatars"
                                [routerLinkData]="owner?.routerLink"
                            ></molecule-info-card>

                            @if (!readonlyView) {
                                <molecule-action-button
                                    class="ms-2"
                                    [actionButton]="
                                        getTmService?.assignActionBtn$
                                            | ngrxPush
                                    "
                                    (onClick)="openLookupAssignTo()"
                                    [tooltip]="assignTooltip"
                                ></molecule-action-button>
                            }
                        </div>
                    </section>
                }

                <section team data-cy="section-team-members">
                    <div class="d-flex justify-content-between">
                        <h5>
                            {{
                                ENUM_TABTYPE_TEAMMEMBERS
                                    | translateTokenisedString
                            }}
                        </h5>

                        @if (!readonlyView) {
                            @if (useLookupAddMember) {
                                @if (hasPermission('Edit') | ngrxPush) {
                                    <button
                                        data-cy="btn-add-team-member"
                                        wdxButton
                                        [wdxIconButton]="true"
                                        (click)="openAddNewMemberModal()"
                                        [ngbTooltip]="addTooltip"
                                    >
                                        <wdx-icon-container size="sm">
                                            <wdx-icon
                                                [icon]="ICON_ADD"
                                            ></wdx-icon>
                                        </wdx-icon-container>
                                    </button>
                                }
                            } @else {
                                <molecule-action-button
                                    data-cy="btn-add-team-member"
                                    [actionButton]="
                                        getTmService?.actionBtn$ | ngrxPush
                                    "
                                    [tooltip]="addTooltip"
                                ></molecule-action-button>
                            }
                        }
                    </div>

                    <hr />

                    @if (
                        !(getTmService?.teamMembersIsLoading$ | ngrxPush) &&
                        (getTmService?.teamMembers$ | ngrxPush)?.length
                    ) {
                        <div class="grid">
                            @for (
                                team of getTmService.teamMembers$ | ngrxPush;
                                track team?.infoCard?.entityId
                            ) {
                                <molecule-info-card
                                    class="g-col-6"
                                    [primaryInfo]="team?.infoCard?.primaryInfo"
                                    [secondaryInfo]="
                                        team?.infoCard?.secondaryInfo
                                    "
                                    [tertiaryInfo]="
                                        team?.infoCard?.tertiaryInfo
                                    "
                                    [routerLinkData]="
                                        team?.infoCard?.routerLink
                                    "
                                    [avatars]="team?.infoCard?.avatars"
                                    [fillHorizontalSpace]="false"
                                >
                                    @if (team?.actionButton && !readonlyView) {
                                        <div class="custom-actions">
                                            <molecule-action-button
                                                [actionButton]="
                                                    team?.actionButton
                                                "
                                                data-cy="team-action-button"
                                            ></molecule-action-button>
                                        </div>
                                    }
                                </molecule-info-card>
                            }
                        </div>
                    } @else if (
                        !(getTmService.teamMembers$ | ngrxPush)?.length &&
                        !(getTmService?.teamMembersIsLoading$ | ngrxPush) &&
                        !(getTmService?.teamMembersHasError$ | ngrxPush)
                    ) {
                        <div
                            class="d-flex h-100 justify-content-center align-items-center"
                        >
                            <atom-feature-svg size="xs" [svg]="NO_DATA_SVG">
                                {{
                                    SVG_TEXT_NO_TEAM_MEMBERS
                                        | translateTokenisedString
                                }}
                            </atom-feature-svg>
                        </div>
                    }
                </section>
            </div>
        </section>
    </atom-async-data>
</ng-template>

<ng-container #lookupContainer></ng-container>
